module.exports = __webpack_public_path__ + "static/myslenie-new-6ddb907df62d921c7326c9d0991940d5.jpg";